// theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '13px',
          padding: '6px 10px',
          maxWidth: 300,
          backgroundColor: '#6f6f6f',
          color: '#fff',
        },
        arrow: {
            color: '#6f6f6f',
        },
      },
    },
  },
});

export default theme;